import type { FC } from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@/design-system/button";
import { LoginModalView, languageSelector, useActiveLoginModalContext } from "@/src/contexts";
import { Modal } from "@Components/Modal";

import { UnauthorizedErrorResources } from "./Unauthorized.Resources";
import { UnauthorizedErrorResourcesEn } from "./Unauthorized.Resources.En";

import * as css from "./Unauthorized.module.css";

export interface IUnauthorized {
    redirectOnClose?: string;
    onClose: () => void;
}

export const Unauthorized: FC<IUnauthorized> = (props) => {
    const navigate = useNavigate();
    const { setActiveLoginModal } = useActiveLoginModalContext();
    const [isOpen, setIsOpen] = useState(false);
    const resources = languageSelector(UnauthorizedErrorResources, UnauthorizedErrorResourcesEn);

    useEffect(() => {
        setIsOpen(true);
    }, []);

    if (isOpen === false) {
        return null;
    }

    const onClose = props.onClose || (() => {});

    const loginClick = () => {
        setActiveLoginModal(LoginModalView.Login);
        setIsOpen(false);
        onClose();
    };

    const registerClick = () => {
        setActiveLoginModal(LoginModalView.Registration);
        setIsOpen(false);
        onClose();
    };

    const closeModal = () => {
        if (props.redirectOnClose) {
            navigate(props.redirectOnClose);
            return;
        }

        onClose();
    };

    return (
        <Modal clientId={css.modalUnauthorized} isOpen={isOpen} onClose={closeModal} closeOnBlur={false}>
            <div>{resources.needLogin}</div>
            <Button as="button" size="M" variant="magentaRound" onClick={loginClick}>
                {resources.login}
            </Button>
            <div className={css.register}>
                <span>{resources.needAccount}</span>
                <Button as="button" size="M" variant="transparent" onClick={registerClick}>
                    {resources.register}
                </Button>
            </div>
        </Modal>
    );
};
